import { dataLineHeight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLineHeight = /*#__PURE__*/createIcon(dataLineHeight)
export default IconLineHeight
